import React from 'react';
import PropTypes from 'prop-types';

const FontStyle = ({
  style = {},
  fill = '#336081',
  width = '30px',
  height = '30px',
  className = '',
  viewBox = '0 0 29.759 16.68',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
  >
    <path
      d="M11.039,9.144a3.768,3.768,0,0,0,2.9-3.825c0-2.349-1.674-4.249-4.749-4.249H.991V17.741H9.414c3.149,0,4.849-1.924,4.849-4.524A4.067,4.067,0,0,0,11.039,9.144Zm-7.123-5.5h4.7a2.11,2.11,0,0,1,2.325,2.149A2.085,2.085,0,0,1,8.614,7.943h-4.7ZM8.739,15.167H3.916V10.518H8.739a2.3,2.3,0,0,1,2.525,2.324A2.239,2.239,0,0,1,8.739,15.167Z"
      transform="translate(-0.991 -1.07)"
      fill={fill}
    />
    <path
      d="M30.75,2a.75.75,0,0,1-.75.75H26.576l-3.6,13.5H26a.75.75,0,0,1,0,1.5H18a.75.75,0,0,1,0-1.5h3.424l3.6-13.5H22a.75.75,0,0,1,0-1.5h8A.75.75,0,0,1,30.75,2Z"
      transform="translate(-0.991 -1.07)"
      fill={fill}
    />
  </svg>
);

FontStyle.propTypes = {
  style: PropTypes.shape({}),
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string,
};

export default FontStyle;
